import React from "react";
import BaseFlexContainer from "../../sisu/layout/BaseFlexContainer.sisu";

const NeoFlexContainer = (props) => {
  return (<BaseFlexContainer custom="p-d-flex" {...props}>{props.children}</BaseFlexContainer>);
};

export default NeoFlexContainer;